/* eslint-disable no-shadow */
/* eslint-disable */
/* eslint-disable max-lines-per-function */
import React from 'react';
import PropTypes from 'prop-types';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { DEAL_TRANSITION_FORM } from '../../../../Constants/strings';
import './transitionForm.scss';
import dayjs from 'dayjs';
import { Controller } from 'react-hook-form';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import DOCUMENT_ICON from '../../../../Assets/images/svg/dar_document_icon.svg';
import CLOSE_ICON from '../../../../Assets/images/svg/dar_cancel.svg';

const InputField = ({ q, register, handleInputChange, errors, currentAction, selectedValues, prefilledValues, control, savedQuestions, handleFileUpload, handleRemoveFile, uploadedFiles }) => {
    const getValidationRules = () => {
        const isSavedForLater = savedQuestions[q.id]?.isSaved || false;

        if (isSavedForLater) {
            return {};
        }
    
        const isRequired = currentAction !== 'draft' && q.question.includes('*') && !q.readOnly;

        const rules = {
            required: isRequired ? `${q.question.replace('*', '').trim()} is required` : false,
        };

        if (q.type === 'email') {
            rules.pattern = {
                value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                message: 'Please enter a valid email address',
            };
        }

        return rules;
    };


    const validationRules = getValidationRules();

    const renderField = () => {
        switch (q.type) {
            case 'text':
            case 'email':
                return (
                    <input
                        type={q.type}
                        {...register(`question${q.id}`, validationRules)}
                        readOnly={q.readOnly}
                        className={q.readOnly ? 'read-only-textbox' : ''}
                        onChange={(e) => handleInputChange(q, e.target.value)}
                    />
                );
            case 'textarea':
                return (
                    <textarea
                        {...register(`question${q.id}`, validationRules)}
                        onChange={(e) => handleInputChange(q, e.target.value)}
                    />
                );
                case 'dropdown':
                    return (
                        <>
                        <select
                        {...register(`question${q.id}`, validationRules)}
                        value={selectedValues?.[q.id] || prefilledValues?.[q.id] || ''}
                        onChange={(e) => handleInputChange(q, e.target.value, 'dropdown')}
                        className="dropdown"
                      >
                        <option value="" disabled>-- Select an option --</option>
                        {q.options?.map((option) => (
                          <option key={option.id} value={option.name}>
                            {option.name}
                          </option>
                        ))}
                        <option value="Other">Other</option>
                      </select>
                      
                      {selectedValues?.[q.id] === 'Other' && (
                        <input
                          type="text"
                          placeholder="Please specify"
                          {...register(`question${q.id}_other`, validationRules)}
                          value={selectedValues?.[`${q.id}_other`] || prefilledValues?.[`${q.id}_other`]}
                          onChange={(e) => {
                            handleInputChange([`${q.id}_other`], e.target.value, 'Other');
                          }}
                          className="other-input"
                        />
                      )}
                            {errors[`question${q.id}_other`] && (
                                <p
                                style={{
                                  color: 'red',
                                  fontSize: '14px',
                                  marginTop: '10px',
                                }}
                              >{errors[`question${q.id}_other`]?.message}</p>
                            )}
                        </>
                    );
                
            case 'radio': return q.options.map((option) => (
                <div className="radio-group" key={option.id}>
                    <input
                        type="radio"
                        id={`option-${q.id}-${option.id}`}
                        value={String(option.id)}
                        {...register(`question${q.id}`, validationRules)}
                        checked={
                            String(selectedValues?.[`question${q.id}`]?.[0]) === String(option.id) ||
                            (!selectedValues?.[`question${q.id}`] &&
                                String(prefilledValues?.[`question${q.id}`]?.[0]) === String(option.id))
                        }
                        onChange={(e) => {
                            handleInputChange(q, e.target.value, 'radio');
                        }}
                    />
                    <label htmlFor={`option-${q.id}-${option.id}`}>{option.name}</label>

                    {option.name === 'Other' &&
                       ( String(selectedValues?.[`question${q.id}`]?.[0]) === String(option.id) || prefilledValues?.[`question${q.id}_other`]) && (
                            <input
                                type="text"
                                className="other-textbox"
                                {...register(`question${q.id}_other`, validationRules)}
                                value={selectedValues?.[`${q.id}_other`] ?? prefilledValues?.[`${q.id}_other`] ?? ''}
                                onChange={(e) => {
                                    handleInputChange(q, e.target.value, 'Other');
                                }}
                                style={{
                                    display: 
                                        String(selectedValues?.[`question${q.id}`]?.[0]) === String(option.id) || 
                                        (!selectedValues?.[`question${q.id}`] && prefilledValues?.[`question${q.id}_other`]) 
                                        ? 'block' 
                                        : 'none'
                                }}
                            />
                        )}                    
                </div>

            ));

            case 'checkbox':
                return q.options.map((option) => {
                    const currentSelection = selectedValues[q.id] || prefilledValues[`question${q.id}`] || [];
                    return (
                        <div key={option.id} className="radio-group">
                            <input
                                type="checkbox"
                                id={`option-${q.id}-${option.id}`}
                                value={option.id}
                                {...register(`question${q.id}`, validationRules)}
                                checked={currentSelection.includes(option.id)}
                                onChange={(e) => {
                                    handleInputChange(q, option.id, 'checkbox');
                                }}
                            />
                            <label htmlFor={`option-${q.id}-${option.id}`}>{option.name}</label>

                            {option.name === 'Other' && currentSelection.includes(option.id) && (
                                <input
                                    type="text"
                                    className="other-textbox"
                                    {...register(`question${q.id}_other`, validationRules)}
                                    value={selectedValues?.[`${q.id}_other`] || prefilledValues?.[`${q.id}_other`]}
                                onChange={(e) => {
                                    handleInputChange(`${q.id}_other`, e.target.value, 'Other');
                                }}
                                />
                            )}
                        </div>
                    );
                });


            case 'file':
                return (
                    <div className="file-upload-container">
                        <input
                            type="file"
                            accept=".jpg,.jpeg,.png,.pdf"
                            multiple
                            id={`fileUpload${q.id}`}
                            {...register(`fileUpload${q.id}`)}
                            style={{ display: 'none' }}
                            onChange={(e) =>
                                handleFileUpload(e,q.id)
                            }
                        />
                        {uploadedFiles[q.id] && uploadedFiles[q.id].length > 0 && (
                            <div className="uploaded-files-list">
                                {uploadedFiles[q.id].map((file, index) => (
                                    <div key={file.name} className="uploaded-file-item">
                                        <img src={DOCUMENT_ICON} alt="Document Icon" />
                                        <span style={{ fontSize: '14px' }}>{file.name}</span>
                                        <button
                                            className="remove-file-button"
                                            onClick={() => handleRemoveFile(q.id, index)}
                                            aria-label={`Remove ${file.name}`}
                                        >
                                            <img src={CLOSE_ICON} alt="Remove file" />
                                        </button>
                                    </div>
                                ))}
                            </div>
                        )}
                        <button
                            type="button"
                            className="custom-file-upload-button"
                            onClick={() =>
                                document.getElementById(`fileUpload${q.id}`).click()
                            }
                        >
                            <FileUploadOutlinedIcon sx={{color: '#6b5ce8', marginRight: '5px'}}/>
                            {' '}
                            {DEAL_TRANSITION_FORM.UPLOAD_FILE}
                        </button>
                       
                      
                    </div>
                )
            case 'date':
                return (
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={['DatePicker']}>
                            <Controller
                                name={`question${q.id}`}
                                control={control}
                                rules={validationRules}
                                render={({ field }) => (
                                    <DatePicker
                                        className="date-container"
                                        label="Date/Month/Year"
                                        {...field}
                                        value={
                                            field.value
                                                ? dayjs(field.value, 'YYYY-MM-DD')
                                                : null
                                        }
                                        onChange={(newDate) => {
                                            const formattedDate =
                                                newDate?.format('YYYY-MM-DD');
                                            field.onChange(formattedDate);
                                            handleInputChange(q, formattedDate, 'date');
                                        }}
                                    />
                                )}
                            />
                        </DemoContainer>
                    </LocalizationProvider>
                );
            default:
                return null;
        }
    };

    return (
        <div className="panel">
            <label>
                {q.question}
                {q.description && (
                    <>
                        <br />
                        <span>{q.description}</span>
                    </>
                )}
            </label>
            {renderField()}
            {errors[`question${q.id}`] && (
               <p
               style={{
                fontFamily: 'Mukta',
                 color: 'red',
                 fontSize: '14px',
                 marginTop: '10px',
               }}
             >
               {errors[`question${q.id}`].message}
             </p>
            )}
        </div>
    );
};
InputField.propTypes = {
    q: PropTypes.shape({
        id: PropTypes.number.isRequired,
        question: PropTypes.string.isRequired,
        description: PropTypes.string,
        type: PropTypes.string.isRequired,
        saveForLater: PropTypes.bool,
        options: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.number.isRequired,
                name: PropTypes.string.isRequired,
            })
        ),
        readOnly: PropTypes.bool,
    }).isRequired,
    register: PropTypes.func.isRequired,
    handleInputChange: PropTypes.func.isRequired,
    errors: PropTypes.object.isRequired,
    currentAction: PropTypes.string.isRequired,
    selectedValues: PropTypes.object.isRequired,
    prefilledValues: PropTypes.object,
    control:PropTypes.object.isRequired,
    savedQuestions:PropTypes.object.isRequired,
    handleFileUpload:PropTypes.func.isRequired,
    handleRemoveFile:PropTypes.func.isRequired,
    uploadedFiles: PropTypes.object.isRequired,
  };
export default InputField;
